var _path, _g, _rect, _rect2, _rect3, _g2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g3, _path2, _path3, _g4, _rect10, _rect11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5578,
    height: 1366,
    viewBox: "0 0 5578 1366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1674.6 388.8H1737.8V702.4L2044.2 388.8H2128.2L1882.6 636L2146.6 1016H2064.2L1832.2 684L1737.8 778.4V1016H1674.6V388.8ZM2187.06 588H2244.66V1016H2187.06V588ZM2215.06 407.2C2226.26 407.2 2235.6 410.933 2243.06 418.4C2250.53 425.867 2254.26 436.533 2254.26 450.4C2254.26 464.267 2250.8 474.933 2243.86 482.4C2236.93 489.867 2227.33 493.6 2215.06 493.6C2202.8 493.6 2193.2 489.333 2186.26 480.8C2179.86 472.267 2176.66 462.4 2176.66 451.2C2176.66 433.6 2180.66 421.867 2188.66 416C2196.66 410.133 2205.46 407.2 2215.06 407.2ZM2956.01 741.6V1016H2897.61V728C2897.61 697.6 2887.21 673.067 2866.41 654.4C2848.81 638.4 2828.01 630.4 2804.01 630.4C2768.27 630.4 2736.27 646.933 2708.01 680C2680.27 712.533 2666.41 752.8 2666.41 800.8V1016H2608.01V728C2608.01 699.2 2598.14 676 2578.41 658.4C2559.74 639.733 2538.41 630.4 2514.41 630.4C2479.74 630.4 2448.81 645.867 2421.61 676.8C2391.74 710.933 2376.81 753.067 2376.81 803.2V1016H2318.41V588H2372.81L2375.21 656C2390.67 630.933 2412.81 611.2 2441.61 596.8C2467.21 584.533 2493.07 578.4 2519.21 578.4C2559.74 578.4 2593.87 590.133 2621.61 613.6C2641.87 631.2 2654.67 648.8 2660.01 666.4C2670.67 646.667 2685.87 628.8 2705.61 612.8C2736.54 589.867 2770.67 578.4 2808.01 578.4C2853.34 578.4 2888.54 592 2913.61 619.2C2941.87 650.133 2956.01 690.933 2956.01 741.6ZM3638.32 625.6V700.8C3608.45 672.533 3577.79 652.267 3546.32 640C3537.25 636.267 3527.92 633.867 3518.32 632.8C3508.72 631.2 3499.12 630.4 3489.52 630.4C3445.25 630.4 3408.99 646.933 3380.72 680C3352.45 714.133 3338.32 754.667 3338.32 801.6C3338.32 849.6 3352.99 890.667 3382.32 924.8C3411.65 957.333 3448.45 973.6 3492.72 973.6C3520.45 973.6 3545.79 967.733 3568.72 956C3591.65 943.733 3614.85 925.6 3638.32 901.6V977.6C3610.05 995.2 3584.45 1007.73 3561.52 1015.2C3538.59 1022.67 3515.39 1026.4 3491.92 1026.4C3432.19 1026.4 3380.99 1005.07 3338.32 962.4C3296.72 918.133 3275.92 864.8 3275.92 802.4C3275.92 741.067 3296.45 688.267 3337.52 644C3379.12 600.267 3430.85 578.4 3492.72 578.4C3524.19 578.4 3553.52 583.733 3580.72 594.4C3596.72 600.267 3615.92 610.667 3638.32 625.6ZM3903.56 1026.4C3848.63 1026.4 3800.36 1006.4 3758.76 966.4C3714.5 924.267 3692.36 869.6 3692.36 802.4C3692.36 738.933 3711.83 685.867 3750.76 643.2C3790.76 600 3840.1 578.4 3898.76 578.4C3956.9 578.4 4005.96 600 4045.96 643.2C4085.43 685.867 4105.16 738.667 4105.16 801.6C4105.16 867.733 4083.83 922.4 4041.16 965.6C4001.7 1006.13 3955.83 1026.4 3903.56 1026.4ZM3897.96 973.6C3936.36 973.6 3970.5 957.6 4000.36 925.6C4029.16 893.067 4043.56 851.733 4043.56 801.6C4043.56 749.867 4028.1 707.733 3997.16 675.2C3968.9 645.333 3936.1 630.4 3898.76 630.4C3860.36 630.4 3827.56 645.867 3800.36 676.8C3770.5 710.933 3755.56 752.8 3755.56 802.4C3755.56 852.533 3770.23 894.4 3799.56 928C3826.76 958.4 3859.56 973.6 3897.96 973.6ZM4225.97 977.6V1153.6H4169.97V588H4221.97L4225.17 665.6C4242.77 636.8 4263.04 615.2 4285.97 600.8C4308.9 585.867 4336.64 578.4 4369.17 578.4C4422.5 578.4 4466.77 599.2 4501.97 640.8C4520.1 661.6 4533.7 685.067 4542.77 711.2C4551.84 736.8 4556.37 765.6 4556.37 797.6C4556.37 863.733 4536.37 918.4 4496.37 961.6C4456.37 1004.8 4408.64 1026.4 4353.17 1026.4C4325.44 1026.4 4299.84 1020.53 4276.37 1008.8C4269.44 1006.13 4261.97 1002.13 4253.97 996.8C4245.97 991.467 4236.64 985.067 4225.97 977.6ZM4225.97 788V916C4234.5 924 4242.24 930.933 4249.17 936.8C4256.64 942.133 4263.3 946.667 4269.17 950.4C4295.3 965.867 4321.7 973.6 4348.37 973.6C4391.04 973.6 4425.97 956.8 4453.17 923.2C4480.9 888 4494.77 845.333 4494.77 795.2C4494.77 748.267 4481.97 709.067 4456.37 677.6C4431.3 646.133 4399.3 630.4 4360.37 630.4C4320.37 630.4 4287.3 647.733 4261.17 682.4C4237.7 713.867 4225.97 749.067 4225.97 788ZM4608.94 588H4666.54V1016H4608.94V588ZM4636.94 407.2C4648.14 407.2 4657.47 410.933 4664.94 418.4C4672.4 425.867 4676.14 436.533 4676.14 450.4C4676.14 464.267 4672.67 474.933 4665.74 482.4C4658.8 489.867 4649.2 493.6 4636.94 493.6C4624.67 493.6 4615.07 489.333 4608.14 480.8C4601.74 472.267 4598.54 462.4 4598.54 451.2C4598.54 433.6 4602.54 421.867 4610.54 416C4618.54 410.133 4627.34 407.2 4636.94 407.2ZM4740.28 388.8H4797.88V1016H4740.28V388.8ZM5073.88 1026.4C5018.94 1026.4 4970.68 1006.4 4929.08 966.4C4884.81 924.267 4862.68 869.6 4862.68 802.4C4862.68 738.933 4882.14 685.867 4921.08 643.2C4961.08 600 5010.41 578.4 5069.08 578.4C5127.21 578.4 5176.28 600 5216.28 643.2C5255.74 685.867 5275.48 738.667 5275.48 801.6C5275.48 867.733 5254.14 922.4 5211.48 965.6C5172.01 1006.13 5126.14 1026.4 5073.88 1026.4ZM5068.28 973.6C5106.68 973.6 5140.81 957.6 5170.68 925.6C5199.48 893.067 5213.88 851.733 5213.88 801.6C5213.88 749.867 5198.41 707.733 5167.48 675.2C5139.21 645.333 5106.41 630.4 5069.08 630.4C5030.68 630.4 4997.88 645.867 4970.68 676.8C4940.81 710.933 4925.88 752.8 4925.88 802.4C4925.88 852.533 4940.54 894.4 4969.88 928C4997.08 958.4 5029.88 973.6 5068.28 973.6ZM5390.68 461.6H5443.48V587.2H5556.28V639.2H5443.48V911.2C5443.48 933.6 5447.48 949.6 5455.48 959.2C5464.01 968.8 5478.41 973.6 5498.68 973.6C5510.41 973.6 5520.28 972.267 5528.28 969.6C5536.81 966.933 5546.15 963.467 5556.28 959.2V1011.2C5547.75 1013.87 5537.35 1016.27 5525.08 1018.4C5513.35 1021.07 5501.35 1022.4 5489.08 1022.4C5457.08 1022.4 5432.28 1015.2 5414.68 1000.8C5394.95 985.867 5385.08 961.867 5385.08 928.8V639.2H5313.08V587.2H5385.08L5390.68 461.6Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1409_144)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 750.01,
    y: 750.01,
    width: 600,
    height: 600,
    rx: 60,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1155.01,
    y: 1190.01,
    width: 40,
    height: 40,
    transform: "rotate(-180 1155.01 1190.01)",
    fill: "#0575E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1070.01,
    y: 1190.01,
    width: 40,
    height: 40,
    transform: "rotate(-180 1070.01 1190.01)",
    fill: "#021B79"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 985.01,
    y: 1190.01,
    width: 40,
    height: 40,
    transform: "rotate(-180 985.01 1190.01)",
    fill: "#021B79"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1409_144)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 750,
    y: 100,
    width: 600,
    height: 600,
    rx: 60,
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 40,
    transform: "matrix(0 1 1 0 1030 260)",
    fill: "#021B79"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 40,
    transform: "matrix(0 1 1 0 1030 430)",
    fill: "#0575E6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 430,
    width: 130,
    height: 40,
    transform: "rotate(-180 1200 430)",
    fill: "#0575E6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 430,
    width: 170,
    height: 40,
    transform: "rotate(-180 1070 430)",
    fill: "#021B79"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1030,
    y: 430,
    width: 56.5685,
    height: 40,
    transform: "rotate(-45 1030 430)",
    fill: "#0575E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "matrix(0 1 1 0 1070 430)",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1409_144)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 750,
    width: 600,
    height: 600,
    rx: 60,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236.508 1035C242.908 1035 248.374 1033.93 252.908 1031.8C257.441 1029.4 261.174 1026.47 264.108 1023C267.308 1019.27 269.574 1015.13 270.908 1010.6C272.508 1005.8 273.308 1001 273.308 996.2V924.2C273.308 913.266 274.508 903.533 276.908 895C279.308 886.466 283.441 879.4 289.308 873.8C295.174 867.933 302.908 863.533 312.508 860.6C322.374 857.4 334.508 855.8 348.908 855.8H350.508V885C335.308 885 324.374 887.8 317.708 893.4C311.308 898.733 308.108 909.133 308.108 924.6V986.2C308.108 1003.8 305.708 1017.4 300.908 1027C296.374 1036.6 289.841 1044.07 281.308 1049.4C289.841 1054.73 296.374 1062.2 300.908 1071.8C305.708 1081.4 308.108 1095 308.108 1112.6V1174.2C308.108 1189.67 311.308 1200.07 317.708 1205.4C324.374 1211 335.308 1213.8 350.508 1213.8V1243H348.908C334.508 1243 322.374 1241.53 312.508 1238.6C302.908 1235.67 295.174 1231.27 289.308 1225.4C283.441 1219.53 279.308 1212.33 276.908 1203.8C274.508 1195.27 273.308 1185.53 273.308 1174.6V1102.6C273.308 1097.8 272.508 1093.13 270.908 1088.6C269.574 1083.8 267.308 1079.67 264.108 1076.2C261.174 1072.47 257.441 1069.53 252.908 1067.4C248.374 1065 242.908 1063.8 236.508 1063.8V1035Z",
    fill: "#021B79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M563.489 1063.8C557.089 1063.8 551.622 1065 547.089 1067.4C542.556 1069.53 538.689 1072.47 535.489 1076.2C532.556 1079.67 530.289 1083.8 528.689 1088.6C527.356 1093.13 526.689 1097.8 526.689 1102.6V1174.6C526.689 1185.53 525.489 1195.27 523.089 1203.8C520.689 1212.33 516.556 1219.53 510.689 1225.4C504.822 1231.27 496.956 1235.67 487.089 1238.6C477.489 1241.53 465.489 1243 451.089 1243H449.489V1213.8C464.689 1213.8 475.489 1211 481.889 1205.4C488.556 1200.07 491.889 1189.67 491.889 1174.2V1112.6C491.889 1095 494.156 1081.4 498.689 1071.8C503.489 1062.2 510.156 1054.73 518.689 1049.4C510.156 1044.07 503.489 1036.6 498.689 1027C494.156 1017.4 491.889 1003.8 491.889 986.2V924.6C491.889 909.133 488.556 898.733 481.889 893.4C475.489 887.8 464.689 885 449.489 885V855.8H451.089C465.489 855.8 477.489 857.4 487.089 860.6C496.956 863.533 504.822 867.933 510.689 873.8C516.556 879.4 520.689 886.466 523.089 895C525.489 903.533 526.689 913.266 526.689 924.2V996.2C526.689 1001 527.356 1005.8 528.689 1010.6C530.289 1015.13 532.556 1019.27 535.489 1023C538.689 1026.47 542.556 1029.4 547.089 1031.8C551.622 1033.93 557.089 1035 563.489 1035V1063.8Z",
    fill: "#0575E6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1409_144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    rx: 60,
    fill: "white"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 40,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 246.777 478.552)",
    fill: "#0575E6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 395.269,
    y: 330.06,
    width: 250,
    height: 40,
    transform: "rotate(-135 395.269 330.06)",
    fill: "#021B79"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1409_144",
    x: 745.01,
    y: 745.01,
    width: 620,
    height: 620,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1409_144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1409_144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1409_144",
    x: 745,
    y: 95,
    width: 620,
    height: 620,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1409_144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1409_144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1409_144",
    x: 95,
    y: 745,
    width: 620,
    height: 620,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1409_144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1409_144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1409_144",
    x: 0,
    y: 0,
    width: 620,
    height: 620,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1409_144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1409_144",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKim);
export default __webpack_public_path__ + "static/media/kim.be18a750132a23720251db0653a46914.svg";
export { ForwardRef as ReactComponent };